import { Icon } from '@scale/scaleui';
import React, { useState, useRef } from 'react';
import NotificationDropDown from './NotificationDropDown';
import { useGetOpsHubNotifications } from './_data/useOpsHubNotifications';
import { useClickAway } from 'react-use-v13';
import { twMerge } from 'tailwind-merge';
import { logNotificationBellClick } from './_data/telemetry';
import { useUser } from 'react-scale/components/ui/UserContext';

const NotificationBell: React.FC = () => {
  const { data: notifications, isLoading } = useGetOpsHubNotifications();
  const [isOpen, setIsOpen] = useState(false);

  const bellRef = useRef<HTMLDivElement>(null);
  const unreadCount = notifications?.unread ?? 0;
  const user = useUser();

  useClickAway(bellRef, () => {
    if (isOpen) setIsOpen(false);
  });

  const handleBellClick = () => {
    logNotificationBellClick(user);
    setIsOpen(!isOpen);
  };

  const displayCount = unreadCount > 99 ? '99+' : unreadCount.toString();

  return (
    <div ref={bellRef} className="relative z-[10]">
      <button
        onClick={() => handleBellClick()}
        className={twMerge(
          'p-0 rounded-full hover:bg-neutral-200 focus:outline-none focus:bg-neutral-200 flex items-center justify-center',
          isOpen ? 'bg-neutral-200' : '',
        )}
      >
        <Icon icon={['far', 'bell']} size="lg" />
        {!isLoading && unreadCount > 0 && (
          <div
            id="notification-count"
            className="absolute -top-1 -right-1 px-1.5 py-0.5 rounded-full bg-[#F0F1FF] text-[#613EE0] text-xs font-medium flex items-center justify-center"
          >
            {displayCount}
          </div>
        )}
      </button>
      {isOpen && <NotificationDropDown />}
    </div>
  );
};

export default NotificationBell;
